<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              ref="master"
              :parentData="parentData"
              @action="masterAction"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-lookup :label="$t('Participante')"
                      :formItemConfig="fiOptions"
                      endpoint="empleados"
                      :decorator="['competitor', { rules: [{ required: true, message: 'Valor requerido' }] }]"
            >
            </g-lookup>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-modal
      v-model="visibleModal"
      title="Evaluaciones"
      :footer="null"
      width="90%"
    >
      <a-table size="small"
               :columns="masterModal.tableSetup.columns"
               :dataSource="topics"
               :pagination="false"
               :scroll="{y: 300 }"
               :loading="tableLoading"
               rowKey="id">
        <template slot="itemRender" slot-scope="text, record, fila">
          <a-spin :spinning="loadingIn(record)">
            <div class="spin-content">
              <input
                v-model="topics[fila] && topics[fila].qualification"
                @blur="columnaCambiada (topics[fila])"
                style="width: 100%"
                type="text"
                class="ant-input ant-input-sm ctinput"
              />
            </div>
          </a-spin>
        </template>
        <template slot="itemRenderAssistance" slot-scope="text, record, fila">
          <a-checkbox v-model="topics[fila] && topics[fila].assistance" @change="columnaCambiada (topics[fila], true)">
          </a-checkbox>
        </template>

      </a-table>
    </a-modal>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="Asistencia y evaluación" key="1">
        <asistencia-evaluacion
          v-if="rowSelected"
          :id_competitor="rowSelected"
          :id_calendar="id_calendar"
          ref="evaluacion"
        />
        <span v-else>Seleccione un participante para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        master: {
          endpoint: 'competitor',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'evaluacion',
                  text: 'Evaluación',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'schedule', style: 'color: red'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: '#', dataIndex: 'competitor', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_empleado', sorter: true}
            ]
          }
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        visibleModal: false,
        masterModal: {
          endpoint: 'calendar',
          tableSetup: {
            actions: {
              actions: false
            },
            columns: [
              {title: 'Tema', dataIndex: 'theme'},
              {
                title: 'Calificación',
                dataIndex: 'qualification',
                scopedSlots: {customRender: 'itemRender'}
              },
              {
                title: 'Asistencia',
                dataIndex: 'assistance',
                scopedSlots: {customRender: 'itemRenderAssistance'}
              }
            ]
          }
        },
        topics: [],
        id_competitor: null,
        loading: false,
        tableLoading: false,
        loadingBtn: {},
        keyTopic: 0
      }
    },
    methods: {
      getQualifications (record) {
        this.tableLoading = true
        this.httpClient.getInstance().post('qualifications_', {
          id_competitor: record.id,
          id_calendar: this.id_calendar
        }).then((response) => {
          this.topics = response.data
        }).catch((error) => {
          Mensajes.error(this.$getErrorMessage(error, 'No fue posible consultar las calificaciones.'))
        }).then(() => {
          this.tableLoading = false
        })
      },
      masterAction (action) {
        switch (action.action) {
          case 'evaluacion':
            this.getQualifications(action.record)
            this.id_competitor = action.record.id
            this.visibleModal = true
            break
        }
      },
      columnaCambiada (topic, isassistance = false) {
        if (isFinite(topic.qualification)) {
          this.loadingBtn[topic.id] = true
          this.$forceUpdate()
          this.httpClient.getInstance().post('trn_qualifications', {
            qualification: topic.qualification,
            id_competitor: this.id_competitor,
            evaluator: true,
            id_calendar: topic.id,
            assistance: topic.assistance,
            isassistance: isassistance
          }).then((response) => {
            this.loadDataEvaluacion()
          }).catch((error) => {
            Mensajes.error(this.$getErrorMessage(error, 'No fue posible guardar la calificación.'))
          }).then(() => {
            this.loadingBtn[topic.id] = false
            this.$forceUpdate()
          })
        }
      },
      loadDataEvaluacion () {
        this.$refs.evaluacion.loadData()
      },
      loadingIn (record) {
        if (this.loadingBtn.hasOwnProperty(record.id)) {
          return this.loadingBtn[record.id]
        } else {
          return false
        }
      }
    },
    props: ['id_calendar'],
    computed: {
      parentData () {
        return {
          id_calendar: this.id_calendar
        }
      },
      rowSelected () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Capacitaciones/Competitors.vue